/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1CoursefinancialCoursefinancialidClassesId200,
  PutApiV1CoursefinancialCoursefinancialidClassesId400,
  PutApiV1CoursefinancialCoursefinancialidClassesId401,
  PutApiV1CoursefinancialCoursefinancialidClassesId404,
  PutApiV1CoursefinancialCoursefinancialidClassesId500,
  PutApiV1CoursefinancialCoursefinancialidClassesIdMutationRequest,
  PutApiV1CoursefinancialCoursefinancialidClassesIdMutationResponse,
  PutApiV1CoursefinancialCoursefinancialidClassesIdPathParams,
} from "../../types/courseFinancialClassesController/PutApiV1CoursefinancialCoursefinancialidClassesId.ts";
import { courseFinancialClassStudentEditorViewModelSchema } from "../courseFinancialClassStudentEditorViewModelSchema.ts";
import { courseFinancialClassStudentViewModelSchema } from "../courseFinancialClassStudentViewModelSchema.ts";

export const putApiV1CoursefinancialCoursefinancialidClassesIdPathParamsSchema =
  z.object({
    courseFinancialId: z.coerce.number().int(),
    id: z.coerce.number().int(),
  }) as unknown as ToZod<PutApiV1CoursefinancialCoursefinancialidClassesIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1CoursefinancialCoursefinancialidClassesId200Schema =
  z.lazy(
    () => courseFinancialClassStudentViewModelSchema,
  ) as unknown as ToZod<PutApiV1CoursefinancialCoursefinancialidClassesId200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1CoursefinancialCoursefinancialidClassesId400Schema =
  z.any() as unknown as ToZod<PutApiV1CoursefinancialCoursefinancialidClassesId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1CoursefinancialCoursefinancialidClassesId401Schema =
  z.any() as unknown as ToZod<PutApiV1CoursefinancialCoursefinancialidClassesId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1CoursefinancialCoursefinancialidClassesId404Schema =
  z.any() as unknown as ToZod<PutApiV1CoursefinancialCoursefinancialidClassesId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1CoursefinancialCoursefinancialidClassesId500Schema =
  z.any() as unknown as ToZod<PutApiV1CoursefinancialCoursefinancialidClassesId500>;

export const putApiV1CoursefinancialCoursefinancialidClassesIdMutationRequestSchema =
  z.lazy(
    () => courseFinancialClassStudentEditorViewModelSchema,
  ) as unknown as ToZod<PutApiV1CoursefinancialCoursefinancialidClassesIdMutationRequest>;

export const putApiV1CoursefinancialCoursefinancialidClassesIdMutationResponseSchema =
  z.lazy(
    () => putApiV1CoursefinancialCoursefinancialidClassesId200Schema,
  ) as unknown as ToZod<PutApiV1CoursefinancialCoursefinancialidClassesIdMutationResponse>;
